import { MessageChannel } from "config/CustomEnums";
import {
  secondEmailStepValidate,
  secondPushStepValidate,
  secondSmsStepValidate,
  secondWhatsappStepValidate,
  secondWechatStepValidate,
} from "../message/CreateMessageValidate";
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from "config/PageAnchorConfig/CampaignAnchorConfig";

export const recurringMessageValidate = ({ getValues, errorList }) => {
  const [
    recurringMessage,
    channels,
  ] = getValues([
    "recurringMessage",
    "recurringMessage.channels",
  ]);
  console.log("@@29", recurringMessage);

  if (channels && channels?.length > 0) {
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.allWechat)
      || channels?.includes(MessageChannel.pushAndInbox)
      || channels?.includes(MessageChannel.push)
      || channels?.includes(MessageChannel.inbox)
    ) {
      const pushValidate = secondPushStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!pushValidate) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
          name: `recurringMessage.channel.${MessageChannel.pushAndInbox}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.allWechat)
      || channels?.includes(MessageChannel.email)
    ) {
      const emailValidate = secondEmailStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!emailValidate) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
          name: `recurringMessage.channel.${MessageChannel.email}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.all)
      || channels?.includes(MessageChannel.sms)
    ) {
      const smsValidate = secondSmsStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!smsValidate) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
          name: `recurringMessage.channel.${MessageChannel.sms}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.allWhatsapp)
      || channels?.includes(MessageChannel.whatsapp)
    ) {
      const whatsappValidate = secondWhatsappStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!whatsappValidate) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
          name: `recurringMessage.channel.${MessageChannel.whatsapp}`,
          message: "have errors inside",
        })
      }
    };
    if (
      channels?.includes(MessageChannel.allWechat)
      || channels?.includes(MessageChannel.wechat)
    ) {
      const wechatValidate = secondWechatStepValidate({ getValues, errorList, additionalFieldName: "recurringMessage." });
      if (!wechatValidate) {
        errorList.push({
          sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
          name: `recurringMessage.channel.${MessageChannel.wechat}`,
          message: "have errors inside",
        })
      }
    };
  }
};
